// French for the login screen. Pre-auth there is no LocaleProvider above the page, so this
// catalogue is also exported: LoginPage.tsx reads it directly, keyed by the browser language,
// and registers it here for the rest of the console.
import { registerFr } from '../i18n/index.js';
import type { Dict } from '../../shared/i18n.js';

export const fr: Dict = {
  'Sign in': 'Se connecter',
  'Signing in…': 'Connexion…',
  'Access to the relationship record': 'Accès au registre des relations',
  'Email': 'E-mail',
  'Password': 'Mot de passe',
  'your@email.ch': 'votre@email.ch',
  'Enter your password': 'Saisissez votre mot de passe',
  'Log in with SSO': 'Se connecter via SSO',
  'Email is required': 'L’adresse e-mail est requise',
  'Password is required': 'Le mot de passe est requis',
  'Login failed': 'Échec de la connexion',
  'Your email is not authorized to access this application. Contact an administrator.':
    'Votre adresse e-mail n’est pas autorisée pour cette application. Contactez un administrateur.',
  'Authentication failed. Please try again.': 'Échec de l’authentification. Veuillez réessayer.',
  'No email was received from the identity provider.': 'Aucune adresse e-mail n’a été transmise par le fournisseur d’identité.',
  'Only pre-approved email addresses can log in.':
    'Seules les adresses e-mail préapprouvées peuvent se connecter.',
};

registerFr(fr, 'LoginPage');
